module.exports = __webpack_public_path__ + "static/img/logo_bottom.1e0bc90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/logo_bottom.png
// module id = +U77
// module chunks = 9